import '../../modules/mode-components';

import * as angular from 'angular';

import GroupMembershipModalController from './group-membership-modal-controller';
import template from './group-membership-modal.html';

const groupMembershipDirective = function (Modal) {
  return {
    restrict: 'A',
    scope: {
      group: '<',
      owner: '<',
      account: '<',
    },
    link: function ($scope: any, elem, attrs) {
      elem.on('click.groupMembership', (event) => {
        const modal = Modal.open(
          {
            group: $scope.group,
            owner: $scope.owner,
            account: $scope.account,
          },
          {
            controller: GroupMembershipModalController,
            controllerAs: 'ctrl',
            bindToController: true,
            template: template,
          }
        );
      });

      // cleanup handlers
      $scope.$on('$destroy', () => elem.off('click.groupMembership'));
    },
  };
};

groupMembershipDirective.$inject = ['ModalService'];

angular.module('mode.components').directive('editGroupMembership', groupMembershipDirective);
